// eslint-disable-next-line
import React from 'react';
import { Wrapper } from '../../components/Wrapper';
import { ReactComponent as HeroPng } from '../../assets/svg/keabsahan_sertifikat.svg';

const HeroMain: React.FC = () => {
  return (
    <div className="text-center py-24">
      <div className="flex justify-center mb-6">
        <HeroPng className="w-64 h-64" />
      </div>
      <p className="text-2xl font-semibold text-black">Keabsahan Sertifikat</p>
      <p>
        Silakan validasi keabsahan sertifikat Anda dengan mudah dan cepat <br />
        melalui halaman ini. Kirim permintaan validasi untuk memproses validitas
        sertifikat.
      </p>
      <a
        href="https://tte.komdigi.go.id/verifyPDF"
        className="inline-block px-6 py-3 mt-5 bg-green-800 text-white font-semibold rounded-lg hover:bg-green-600 transition duration-300"
      >
        Validasi Sertifikat
      </a>
    </div>
  );
};

const WrapperMain: React.FC = () => {
  return (
    <Wrapper>
      <HeroMain />
    </Wrapper>
  );
};

const KeabsahanSertifikat: React.FC = () => {
  return <WrapperMain />;
};

export default KeabsahanSertifikat;
